import { SelectorListItem } from '../../types/store/selector-list-item';

const CART_QUANTITY_OPTIONS_LENGTH = 10;
export const CART_QUANTITY_OPTIONS: SelectorListItem[] = [
  ...Array(CART_QUANTITY_OPTIONS_LENGTH),
].map((_, index) => ({ value: index + 1, name: String(index + 1) }));
